export default "__VITE_ASSET__CnT_$yJH__"